import { useCallback } from 'react';

import { useMediaQuery, useTheme } from '@mui/material';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router';

import CookieBannerFull from '@/components/CookieBanner/CookieBannerFull/index';
import CookieBannerMobile from '@/components/CookieBanner/CookieBannerMobile/index';
import { clearSelection } from '@/features/SymbolSelector/store/symbolSelector.slice';
import { useAppDispatch } from '@/hooks/redux-hooks';
import { logout } from '@/slices/authSlice';

const CookieBanner = () => {
  const [cookies, setCookie] = useCookies(['cookies-accepted']);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleDecline = useCallback(() => {
    dispatch(clearSelection());
    dispatch(logout());
    navigate('/login');
  }, [dispatch, navigate]);

  const handleAccept = useCallback(() => {
    const expires = new Date();
    expires.setFullYear(expires.getFullYear() + 2);

    setCookie('cookies-accepted', true, {
      expires,
      path: '/',
      sameSite: 'lax',
      secure: window.location.protocol === 'https:'
    });
  }, [setCookie]);

  const theme = useTheme();
  const showMobileBanner = useMediaQuery(theme.breakpoints.down('md'));

  if (cookies['cookies-accepted']) return null;

  return showMobileBanner ? (
    <CookieBannerMobile
      handleAccept={handleAccept}
      handleDecline={handleDecline}
    />
  ) : (
    <CookieBannerFull
      handleAccept={handleAccept}
      handleDecline={handleDecline}
    />
  );
};

export default CookieBanner;
